<template>
    <v-container fluid no-gutters class="default-cursor">
        <v-row>
            <v-col cols="12" class="px-0">
                <v-card class="text-left white--text mb-1 rounded-0" color="#232323">
                    <v-card-title style="font-size: 40px; padding-left: 10px; margin: 0;">Match Center</v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <results-team :matches="getMatches(0,12)" :num-of-matches-to-show="12" size="large" />
        <results-team :matches="getMatches(12,8)" :num-of-matches-to-show="8" />
    </v-container>
</template>

<script>
    import ResultsTeam from '@/components/ResultsCarousel'
    export default {
        components: { ResultsTeam },
        props: {
            matches: {
                type: Array,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        created() {
        },
        methods: {
            getMatches(start, count) {
                return this.matches.slice(start, start + count)
            }
        }
    }
</script>

<style>
.v-window__next,
.v-window__prev {
    background: rgba(0, 0, 0, 0);
    margin: 0 -5px;
}

.left-rounded {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.right-rounded {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>

<style scoped>

.default-cursor {
    cursor: default;
}

.custom-teal {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
}

.losing-score-right {
    outline: solid 2px teal;
    outline-offset: -2px;
    color: black;
    background-color: white;
}

.losing-score-left {
    outline: solid 2px teal;
    outline-offset: -2px;
    color: black;
    background-color: white;
}

.winning-score {
    color: white;
}

.custom-date {
    font-weight: 700;
    font-size: 1rem;

    /* border-style: solid; */
    border-radius: 5px;
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    color: white;
}
</style>
